import React, { Component } from 'react'
import Paper from '@material-ui/core/Paper'
import Lottie from 'react-lottie'

import SuccessLottie from '../../assets/lottie/success.json'
import styles from './Success.css'
import Footer from '../../components/Footer/Footer'


class Success extends Component {
  render () {

    const defaultOptions = {
      loop: false,
      autoplay: true, 
      animationData: SuccessLottie,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    }

    return (
      <div className={styles.Success}>
        <div className={styles.wrapper}>
          <Paper classes={{ root: styles.searchPaper}}>
            <Lottie
              options={defaultOptions}
              height={400}
              width={400}
            />
            <div className={styles.textColumn}>
              <p className={styles.headerText}>Reset Password</p>
              <p className={styles.subHeaderText}>Successfully</p>
            </div>
            
          </Paper>
        </div>
        <Footer />
      </div>
    )
  }
}

export default Success
